import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Slide, Zoom } from "react-awesome-reveal";
import ScrollToTop from "../ScrollToTop";
import "./aboutUs.css";
import { products } from "../../data/productsData";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaGlobe
} from "react-icons/fa";


// Iocns
import boxIcon from "../../images/icons/box.png";
import leavesIcon from "../../images/icons/leaves.png";
import stockIcon from "../../images/icons/stock.png";
import flavour from "../../images/icons/food-safety.png";



// ---------- images (adjust paths if your folders differ) ----------
import logo from "../../images/logo/Kunjveda_logo2.png";
import heroImage from "../../images/banners/spices_resize.webp";
import storyImage from "../../images/adbanner/aboutUs.webp";


import turmericPowder from "../../images/spices/turmeric2.jpg";
import redChilliPowder from "../../images/spices/redChilliPowder.jpg";
import corianderPowder from "../../images/spices/re-coriander.png";
import cuminSeeds from "../../images/spices/bgcuminPowder.png";
import blackPepper from "../../images/spices/blackPepper3.jpg";
import garamMasala from "../../images/spices/garamMasala.jpg";

// ------------------------  Product Images  --------------------------------------
import spiceRedChilliPowder from "../../images/productList/redChilliPowder.png";
import spiceTurmericPowder from "../../images/productList/turmericPowder.png";
import spiceCorianderPowder from "../../images/productList/corianderPowder.png";

import tea from "../../images/otherImages/tea-leaves-powder.webp";
import biryani from "../../images/otherImages/biryani.webp";
import delivery from "../../images/otherImages/delivery-service.webp";

import flipkartlogo from "../../images/flipkartlogo.png";
import amazonlogo from "../../images/amazonlogo.png";
import blinkit from "../../images/blinkit.png";
import zeptologo from "../../images/zeptologo.svg";

// ---------- dynamic data (edit these, the page updates itself) ----------
const stats = [
  { id: 1, value: "50+", label: "Spice Varieties" },
  { id: 2, value: "1000+", label: "Happy Customers" },
  { id: 3, value: "100%", label: "Natural & Pure" },
  { id: 4, value: "Pan India", label: "Delivery" },
];


const values = [
  { id: 1, icon: leavesIcon, title: "Pure & Natural", text: "Carefully selected spices with no artificial colours or flavours, just the real taste of nature." },
  { id: 2, icon: flavour, title: "Authentic Flavour", text: "Rich aroma and traditional taste that bring homemade Indian meals to life." },
  { id: 3, icon: boxIcon, title: "Fresh Packaging", text: "Packed with care in hygienic conditions to lock in freshness for longer." },
  { id: 4, icon: stockIcon, title: "Value in Bulk", text: "Fair wholesale pricing for restaurants, retailers and families who buy in volume." },
];
const process = [
  { id: 1, step: "01", title: "Sourcing", text: "We choose quality raw spices from trusted farms and growers." },
  { id: 2, step: "02", title: "Cleaning", text: "Every batch is cleaned and sorted to remove dust and impurities." },
  { id: 3, step: "03", title: "Grinding", text: "Spices are ground carefully so the natural aroma and oils stay intact." },
  { id: 4, step: "04", title: "Packing", text: "Sealed and packed fresh, then dispatched to your doorstep." },
];

const featuredSpices = [
  { id: 1, name: "Coriander Powder", image: spiceCorianderPowder },
  { id: 2, name: "Red Chilli Powder", image: spiceRedChilliPowder },
  { id: 3, name: "Turmeric Powder", image: spiceTurmericPowder },
  { id: 4, name: "Amla Powder", image: spiceCorianderPowder },
  { id: 5, name: "Amchoor Powder", image: spiceRedChilliPowder },
  { id: 6, name: "Moringa Powder", image: spiceCorianderPowder },
];

const customers = [
  { id: 1, image: biryani, title: "Home Kitchens", text: "Everyday masalas for family meals." },
  { id: 2, image: tea, title: "Cafes & Restaurants", text: "Consistent flavour in every bulk order." },
  { id: 3, image: delivery, title: "Retailers & Resellers", text: "Reliable supply with fast delivery." },
];

const partners = [
  { id: 1, name: "Amazon", logo: amazonlogo },
  { id: 2, name: "Blinkit", logo: blinkit },
  { id: 3, name: "Zepto", logo: zeptologo },
  { id: 4, name: "Flipkart", logo: flipkartlogo },
];

const AboutUs = () => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [sent, setSent] = useState(false);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: send `form` to your API / email service here
    console.log("Enquiry:", form);
    setSent(true);
    setForm({ name: "", email: "", phone: "", message: "" });
  };

  return (
    <div className="au-page">
      <ScrollToTop />

      {/* ============ HERO ============ */}
      <section className="au-hero">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <Slide direction="down" triggerOnce>
                <span className="au-eyebrow">About KunjVeda</span>
                <h1 className="au-title">
                  Purity of Nature, <em>Power of Veda.</em>
                </h1>
                <p className="au-lead">
                  KunjVeda brings you authentic Indian spices, from everyday
                  masalas to premium whole spices, packed fresh for kitchens,
                  cafes and businesses across India.
                </p>
                <div className="d-flex flex-wrap gap-3 mt-4">
                  <Link to="/ProductList" className="btn btn-dark btn-lg">
                    Shop Spices
                  </Link>
                  <a href="#contact" className="btn btn-outline-dark btn-lg">
                    Wholesale Enquiry
                  </a>
                </div>
              </Slide>
            </div>
            <div className="col-lg-6">
              <Zoom triggerOnce>
                <div className="au-hero-img">
                  <img src={heroImage} alt="KunjVeda spices" />
                </div>
              </Zoom>
            </div>
          </div>
        </div>
      </section>

      {/* ============ STATS ============ */}
      <section className="au-stats">
        <div className="container">
          <div className="row g-3 text-center">
            {stats.map((s) => (
              <div className="col-6 col-md-3" key={s.id}>
                <div className="au-stat">
                  <h3>{s.value}</h3>
                  <p>{s.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ OUR STORY ============ */}
      <section className="au-section">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <Slide direction="left" triggerOnce>
                <div className="au-story-img">
                  <img src={storyImage} alt="Our story" loading="lazy" />
                </div>
              </Slide>
            </div>
            <div className="col-lg-6">
              <Slide direction="right" triggerOnce>
                {/* <img src={logo} alt="KunjVeda" className="au-logo" /> */}
                <h2 className="au-h2">Our Story</h2>
                <p>
                  Spices are the heart of every Indian kitchen. KunjVeda was
                  started with a simple idea: bring back the real aroma and
                  taste of pure spices, without shortcuts.
                </p>
                <p>
                  We work closely with growers, clean and grind every batch
                  with care, and pack it fresh so that what reaches your home
                  tastes the way spices are meant to taste.
                </p>
                <ul className="au-checks">
                  <li>Spices in bulk, value in every order</li>
                  <li>Hygienic grinding and packing</li>
                  <li>Honest prices, dependable quality</li>
                </ul>
              </Slide>
            </div>
          </div>
        </div>
      </section>

      {/* ============ WHY CHOOSE US ============ */}
      <section className="au-section au-soft">
        <div className="container">
          <div className="au-head text-center">
            <h2 className="au-h2">Why Choose KunjVeda</h2>
            <div className="au-line" />
            <p>What makes our spices different, in every pack.</p>
          </div>
          <div className="row g-4">
            {values.map((v) => (
              <div className="col-sm-6 col-lg-3 au-eq" key={v.id}>
                <Zoom triggerOnce style={{ height: "100%" }}>
                  <div className="au-card h-100">
                    <div className="au-icon">
                      <img src={v.icon} alt="" style={{ height: "50px" }} />
                    </div>
                    <h4>{v.title}</h4>
                    <p>{v.text}</p>
                  </div>
                </Zoom>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ FROM FARM TO KITCHEN ============ */}
      <section className="au-section">
        <div className="container">
          <div className="au-head text-center">
            <h2 className="au-h2">From Farm to Your Kitchen</h2>
            <div className="au-line" />
            <p>Four simple steps that keep our spices fresh and flavourful.</p>
          </div>
          <div className="row g-4">
            {process.map((p) => (
              <div className="col-sm-6 col-lg-3" key={p.id}>
                <Slide direction="up" triggerOnce>
                  <div className="au-step">
                    <span className="au-step-no">{p.step}</span>
                    <h4>{p.title}</h4>
                    <p>{p.text}</p>
                  </div>
                </Slide>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ FEATURED SPICES ============ */}
      <section className="au-section au-soft">
        <div className="container">
          <div className="d-flex flex-wrap align-items-end justify-content-between mb-4">
            <div>
              <h2 className="au-h2 mb-1">Our Popular Spices</h2>
              <p className="mb-0 text-muted">A taste of what we offer.</p>
            </div>
            <Link to="/ProductList" className="btn btn-outline-dark">
              View all spices
            </Link>
          </div>
          <div className="row g-3">
            {products.map((sp) => (
              <div className="col-12 col-md-4 col-lg-2" key={sp.id}>
                <Zoom triggerOnce>
                  <Link to={`/ProductList/ProductDetail/${sp.id}`} className="au-spice">
                    <img src={sp.image} alt={sp.name} loading="lazy" style={{ height: "180px" }} />
                    <span>{sp.name}</span>
                  </Link>
                </Zoom>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ AVAILABLE ON ============ */}
      <section className="au-section au-soft">
        <div className="container">
          <div className="au-head text-center">
            <h2 className="au-h2">Also Available On</h2>
            <div className="au-line" />
          </div>
          <div className="row g-4 justify-content-center align-items-center text-center">
            {partners.map((p) => (
              <div className="col-6 col-md-3" key={p.id}>
                <img
                  src={p.logo}
                  alt={p.name}
                  className="au-partner"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ CTA BAND ============ */}
      <section className="au-cta">
        <div className="container text-center">
          <h2 style={{ color: "whitesmoke" }}>Looking for spices in bulk?</h2>
          <p>Get special wholesale rates for restaurants, retailers and families.</p>
          <a href="#contact" className="btn btn-light btn-lg">
            Get a Quote
          </a>
        </div>
      </section>

      {/* ============ CONTACT ============ */}
      <section className="au-section" id="contact">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-5">
              <h2 className="au-h2">Get in Touch</h2>
              <p>
                Have a question or want a bulk quote? Send us a message and we
                will get back to you soon.
              </p>
              <ul className="au-contact">
                <li><FaMapMarkerAlt /> {" "} Your business address here</li>
                <li><FaPhoneAlt /> {" "}+91 00000 00000</li>
                <li><FaEnvelope />{" "} info@kunjveda.com</li>
              </ul>
            </div>
            <div className="col-lg-7">
              <iframe aria-label='Inquiry Form' frameborder="0" style={{ height: "400px", width: "99%", border: "none" }} src='https://forms.zohopublic.com/rccrmkanpur1/form/CancellationRequestForm/formperma/_ayTTb5XKnKEdDZIFyUSor-T8bg3vKYS3ctFueWVPtA' >
              </iframe>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
